import React from "react";

const SPACES_FEATURES = [
  {
    num: "01",
    name: "Knowledge Base Spaces",
    title: "Attach security policies & runbooks",
    desc: "Upload architecture specs, security guidelines, and internal compliance docs. Sentry queries your Spaces on demand to surface specific controls during threat analysis.",
  },
  {
    num: "02",
    name: "Architectural Versioning",
    title: "Diff architectures across revisions",
    desc: "Upload revised diagrams or code files. ThreatForge diffs changes incrementally, updating assets and trust boundaries while preserving historical threat models.",
  },
  {
    num: "03",
    name: "Analysis Replay",
    title: "Re-run evaluations with new parameters",
    desc: "Keep custom starred threats intact while re-evaluating risk models with adjusted iteration counts, reasoning depth, or updated threat intelligence feeds.",
  },
];

const COLLAB_FEATURES = [
  {
    num: "04",
    name: "Collaborative Spaces",
    title: "Role-based access controls for security teams",
    desc: "Grant Owner, Editor, or Viewer access per space or project. Share revocable links with auditors and engineering stakeholders.",
  },
  {
    num: "05",
    name: "Conflict-Free Locks",
    title: "Optimistic concurrency edit locks",
    desc: "Prevent team members from overwriting active threat catalog edits with automatic lock management and conflict resolution modals.",
  },
  {
    num: "06",
    name: "Multi-Format Export",
    title: "PDF, DOCX, JSON & CSV Exports",
    desc: "Export complete threat catalogs, attack trees, and compliance mappings in presentation-ready formats with one click.",
  },
];

export default function Spaces() {
  return (
    <section className="tfl-spaces" aria-label="Spaces and Collaboration">
      <div className="tfl-spaces__inner">
        <div className="tfl-spaces__header">
          <div className="tfl-eyebrow">Enterprise Infrastructure</div>
          <h2 className="tfl-display">
            A living threat model that evolves with your codebase.
          </h2>
          <p className="tfl-body-lg" style={{ maxWidth: "620px" }}>
            Point-in-time security documents become stale the moment code ships. ThreatForge persists, versions, and continuously updates threat models across your team.
          </p>
        </div>

        <div className="tfl-spaces__grid">
          <div className="tfl-feat-col">
            <ul className="tfl-feat-list">
              {SPACES_FEATURES.map((f) => (
                <li key={f.num} className="tfl-feat-item">
                  <div className="tfl-feat-item__tag">{f.num} / {f.name}</div>
                  <h3 className="tfl-feat-item__title">{f.title}</h3>
                  <p className="tfl-feat-item__desc">{f.desc}</p>
                </li>
              ))}
            </ul>
          </div>

          <div className="tfl-feat-col">
            <ul className="tfl-feat-list">
              {COLLAB_FEATURES.map((f) => (
                <li key={f.num} className="tfl-feat-item">
                  <div className="tfl-feat-item__tag">{f.num} / {f.name}</div>
                  <h3 className="tfl-feat-item__title">{f.title}</h3>
                  <p className="tfl-feat-item__desc">{f.desc}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
